export default __webpack_public_path__ + "images/avax_1dfdee.svg";